module.exports = __webpack_public_path__ + "img/touxiang.e9b2cbc3.png";